export default __webpack_public_path__ + "static/media/books2-afterA-2048w.b654725a.avif";